import React, { Component } from 'react';
import { Route,Switch,Link,withRouter } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import $ from 'jquery';
import AnaSayfa from './pages/anasayfa';
import DovizSayfa from './pages/dovizsayfa';
import AltinSayfa from './pages/altinsayfa';
import IscilikSayfa from './pages/isciliksayfa';
import FavorilerSayfa from './pages/favorilersayfa';
import "react-toastify/dist/ReactToastify.css";
import { applyIndexingPolicy } from './services/seo';
import { trackPageView } from './services/analytics';

class App extends Component {
  componentDidMount() {
    applyIndexingPolicy();
    // Ilk page_view: index.html'de send_page_view kapali oldugu icin buradan
    // gidiyor. Sayfa bilesenleri once mount oldugundan document.title hazir.
    trackPageView();
  }

  componentDidUpdate(prevProps) {
    // Rota degistiginde canonical'in pathname'i guncel kalsin.
    if (prevProps.location.pathname !== this.props.location.pathname) {
      applyIndexingPolicy();
      trackPageView();
    }
  }

  render() { 
    return <React.Fragment>
            <ToastContainer />
            <div id="wrapper">
              <div id="sidebar-wrapper">
                    <ul className="metismenu mm-show" id="menu">
                      <li className="mm-active">
                        <ul className="mm-collapse mm-show">
                          <li><a href="https://www.altinkaynak.com/?utm_source=canli">ALTINKAYNAK ANASAYFA</a></li>
                          <li><Link to="/" className="" onClick={toggleMenu}>ANASAYFA</Link></li>
                          <li><Link to="/doviz" className=""  onClick={toggleMenu}>DÖVİZ</Link></li>
                          <li><Link to="/altin" className=""  onClick={toggleMenu}>ALTIN & GÜMÜŞ</Link></li>
                          <li><Link to="/iscilik" className=""  onClick={toggleMenu}>İŞÇİLİK</Link></li>
                          <li><Link to="/favoriler" className=""  onClick={toggleMenu}>FAVORİLER</Link></li>
                        </ul>
                      </li>
                    </ul>
                </div>
                <header className="topbar-nav">
                <h1 className="logo"><Link to="/">Altınkaynak</Link></h1>
                  <div className="col-lg-12">
                      <div className="btn-toolbar" role="toolbar">
                          <div className="btn-group mr-1">
                            <a href="https://www.altinkaynak.com/?utm_source=canli" className="btn btn-light waves-effect waves-light small">ALTINKAYNAK<br/>ANASAYFA</a>
                            <Link to="/" className="btn btn-light waves-effect waves-light">ANASAYFA</Link>
                            <Link to="/doviz" className="btn btn-light waves-effect waves-light">DÖVİZ</Link>
                            <Link to="/altin" className="btn btn-light waves-effect waves-light">ALTIN & GÜMÜŞ</Link>
                            <Link to="/iscilik" className="btn btn-light waves-effect waves-light">İŞÇİLİK</Link>
                            <Link to="/favoriler" className="btn btn-light waves-effect waves-light">FAVORİLER</Link>
                          </div>
                          <div className="toggle-menu">
                            <i className="zmdi mobile zmdi-menu" onClick={toggleMenu}></i>
                          </div>
                      </div>
                  </div>
                </header>
                <div className="clearfix"></div>
                <div className="content-wrapper">
                  <div className="container-fluid">
                    <Switch>
                      <Route path="/favoriler" component={FavorilerSayfa} />
                      <Route path="/iscilik" component={IscilikSayfa} />
                      <Route path="/altin" component={AltinSayfa} />
                      <Route path="/doviz" component={DovizSayfa} />
                      <Route path="/" component={AnaSayfa} />
                    </Switch>
                  </div>
                </div>
            </div>
            <footer className="footer">
                  <div className="container">
                    <div className="text-left left">
                      Copyright © 2026 Altınkaynak
                    </div>
                    <div className="text-right right">
                    </div>
                  </div>
                </footer>
          </React.Fragment>
  }
}

function toggleMenu() {
  $("#sidebar-wrapper").toggle();
  $(".toggle-menu").toggleClass('active')
}

export default withRouter(App);
